import { SVGPropsIcon } from 'src/types';

export const Copy = (props: SVGPropsIcon) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M12.7 1.6665H9.45487C7.98466 1.66649 6.82015 1.66648 5.90878 1.7895C4.97085 1.91611 4.21169 2.18287 3.613 2.78397C3.0143 3.38506 2.74861 4.14727 2.62251 5.08898C2.49998 6.00401 2.49999 7.17318 2.5 8.64929V13.5139C2.5 14.7707 3.26663 15.8477 4.35597 16.2992C4.2999 15.5413 4.29995 14.4779 4.3 13.5932L4.3 9.49783L4.3 9.41852C4.29994 8.35046 4.29989 7.4302 4.39857 6.69326C4.50433 5.90348 4.74282 5.14643 5.35442 4.53238C5.96601 3.91833 6.72003 3.67888 7.50665 3.5727C8.24064 3.47362 9.15722 3.47367 10.221 3.47373L10.3 3.47373H12.7L12.779 3.47373C13.8428 3.47367 14.7574 3.47362 15.4914 3.5727C15.0523 2.45633 13.968 1.6665 12.7 1.6665Z"
        fill="white"
      />
      <path
        d="M5.50008 9.49766C5.50008 7.22583 5.50008 6.08992 6.20302 5.38415C6.90597 4.67839 8.03734 4.67839 10.3001 4.67839H12.7001C14.9628 4.67839 16.0942 4.67839 16.7971 5.38415C17.5001 6.08992 17.5001 7.22583 17.5001 9.49766V13.5137C17.5001 15.7856 17.5001 16.9215 16.7971 17.6272C16.0942 18.333 14.9628 18.333 12.7001 18.333H10.3001C8.03734 18.333 6.90597 18.333 6.20302 17.6272C5.50008 16.9215 5.50008 15.7856 5.50008 13.5137V9.49766Z"
        fill="white"
      />
    </svg>
  );
};
